/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import GridWithFilters from '../lists/GridWithFilters';

import * as AppPropTypes from '../../lib/PropTypes';

import styles from '../../../styles/partials/related-footer.module.scss';

const propTypes = {
    title: AppPropTypes.label,
    items: AppPropTypes.pages.isRequired,
    className: PropTypes.string,
};

const defaultProps = {
    title: <FormattedMessage defaultMessage="Related projects" despription="Title label" />,
    className: null,
};

const RelatedFooter = ({ title, items, className }) => (
    <div
        className={classNames([
            styles.container,
            {
                [className]: className !== null,
            },
        ])}
    >
        <h3 className={styles.title}>{title}</h3>
        <div className={styles.grid}>
            <GridWithFilters withoutFilters items={items} itemClassName={styles.item} />
        </div>
    </div>
);

RelatedFooter.propTypes = propTypes;
RelatedFooter.defaultProps = defaultProps;

export default RelatedFooter;
